import { contactInfo } from '@/mocks/animeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
            {contactInfo.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 md:mb-10">
            {contactInfo.desc}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {contactInfo.items.map((item) => (
              <div
                key={item.label}
                className="flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className={`${item.icon} text-primary-500 text-lg md:text-xl`}></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800 mb-1">{item.label}</div>
                  <div className="text-xs md:text-sm text-foreground-500 font-mono">{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}